// eslint-disable-next-line no-unused-vars
import * as React from "react";
import TrendingFlatOutlinedIcon from "@mui/icons-material/TrendingFlatOutlined";
import { Link, styled } from "@mui/material";

export const PanelLink = styled(Link)`
    cursor: pointer;
    margin-right: 16px;
    min-width: 74px;
`;

export const ArrowIcon = styled(TrendingFlatOutlinedIcon)`
    transform: rotate(180deg);
    margin-right: 4px;
`;